import { Component } from 'react';
import PropTypes from 'prop-types';
import FormControl from 'react-bootstrap/lib/FormControl';
import { isNaN, noop, debounce } from 'lodash/fp';

import { formatNumber, formatMoney } from 'helpers/i18n';
import cn from './styles.local.less';

const VALUE_CHANGED_INTERVAL = 1500;

const currencySymbol = formatMoney(0).replace(/\s?0\s?/, '');
const format = (value) => `${currencySymbol} ${formatNumber(value)}`;

const unformat = (value) => {
  if (!value) {
    return 0;
  }

  if (value.replace !== undefined) {
    const unformattedValue = parseInt(value.replace(/[^0-9]/g, ''), 10);

    return isNaN(unformattedValue) ? 0 : unformattedValue;
  }

  return value;
};

export default class Control extends Component {
  static propTypes = {
    defaultValue: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
    qaSelector: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    onBlur: PropTypes.func,
  };

  static defaultProps = {
    onBlur: noop,
  };

  constructor(...args) {
    super(...args);

    this.handleValueChanged = debounce(
      VALUE_CHANGED_INTERVAL,
      this.handleValueChanged,
    );
  }

  state = {
    value: this.props.value || this.props.defaultValue,
  };

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { value } = this.state;

    if (value !== nextProps.value) {
      this.setState({ value: nextProps.value });
    }
  }

  handleChange = (e) => {
    const value = unformat(e.target.value);

    this.setState({ value }, this.handleValueChanged);
  };

  handleBlur = () => {
    const { value } = this.state;
    const { onBlur } = this.props;

    onBlur(value);
    this.handleValueChanged.cancel();
  };

  handleValueChanged = () => {
    const { value } = this.state;
    const { onChange } = this.props;

    onChange(value);
  };

  handleFormat = (value) => {
    const { defaultValue } = this.props;

    if (value === null || value === undefined) {
      return format(defaultValue);
    }

    return format(value);
  };

  render() {
    const { value } = this.state;
    const { qaSelector } = this.props;

    return (
      <FormControl
        value={this.handleFormat(value)}
        onChange={this.handleChange}
        onBlur={this.handleBlur}
        className={cn.root}
        data-qa-selector={qaSelector}
      />
    );
  }
}
